import { TMNotificationPriority, IBaseNotification, TMNotificationType } from "../types";
import { store, actions, userAPI, selectors } from "../../user-area/redux/store";

export abstract class BaseNotificationModel extends EventTarget implements IBaseNotification {
  protected _id: string;
  protected _title: string;
  protected _message: string;
  protected _priority: TMNotificationPriority;
  protected _type: TMNotificationType;
  protected _createdAt?: string;
  protected _readAt?: string;
  protected _data?: unknown;

  constructor(notification: IBaseNotification) {
    super();
    this._id = notification.id;
    this._title = notification.title;
    this._message = notification.message;
    this._priority = notification.priority;
    this._type = notification.type;
    this._createdAt = notification.createdAt;
    this._readAt = notification.readAt;
    this._data = notification.data;
  }

  get id() {
    return this._id;
  }

  get title() {
    return this._title;
  }

  get message() {
    return this._message;
  }

  get priority() {
    return this._priority;
  }

  get type() {
    return this._type;
  }

  get createdAt() {
    return this._createdAt;
  }

  get readAt() {
    return this._readAt;
  }

  get data() {
    return this._data;
  }

  abstract show(): void;

  protected dispatchCompleteEvent() {
    this.dispatchEvent(new CustomEvent('complete', {
      bubbles: true,
      composed: true,
    }));
  }

  public addOnCompleteEventListener(callback: EventListener) {
    this.addEventListener('complete', callback);
  }

  public removeOnCompleteEventListener(callback: EventListener) {
    this.removeEventListener('complete', callback);
  }

  protected markAsDelivered() {
    store.dispatch(actions.notification.markAsDelivered({ id: this._id }));
    const authState = store.getState().auth;
    const authData = selectors.auth.credentials(authState);
    store.dispatch(userAPI.endpoints.deliverNotification.initiate({
      ...authData,
      data: {
        notification: this._id,
      },
    }));
  }

  public getSnapshot(): IBaseNotification {
    return {
      id: this.id,
      title: this.title,
      message: this.message,
      priority: this.priority,
      type: this.type,
      createdAt: this.createdAt,
      readAt: this.readAt,
      data: this.data,
    };
  }
}
